import { useRouteLoaderData } from 'react-router'

import { loader as contentLoader } from './loader'
import { ConsumerFooter } from '~/portal/components/ConsumerFooter'
import { ConsumerLoaderData } from '~/portal/types/portal'

export const loader = contentLoader

export default function Index() {
  const { footer } = useRouteLoaderData<ConsumerLoaderData>('routes/_docs/_index') || {}

  return (
    <div data-testid="product root page" className="flex flex-col h-full overflow-x-hidden">
      <div className="flex-1" />
      {footer?.visible && <ConsumerFooter footer={footer} />}
    </div>
  )
}